import { ReactComponent as Dots } from './3dot.svg';
import { ReactComponent as Age } from './age.svg';
import { ReactComponent as ArrowUpright } from './arrow-upright.svg';
import { ReactComponent as CheckIcon } from './check-icon.svg';
import { ReactComponent as CircleDelete } from './circle-delete.svg';
import { ReactComponent as CirclePlus } from './circle-plus.svg';
import { ReactComponent as ClinicalTrials } from './clinical-trials.svg';
import { ReactComponent as ClockRotateLeft } from './clock-rotate-left.svg';
import { ReactComponent as ClockRotateRight } from './clock-rotate-right.svg';
import { ReactComponent as Delete } from './delete.svg';
import { ReactComponent as DoubleArrowsRight } from './double-arrows-right.svg';
import { ReactComponent as Download } from './download.svg';
import { ReactComponent as Expand } from './expand.svg';
import { ReactComponent as Export } from './export.svg';
import { ReactComponent as FileDoc } from './file-doc.svg';
import { ReactComponent as FilePdf } from './file-pdf.svg';
import { ReactComponent as FileTxt } from './file-txt.svg';
import { ReactComponent as Gender } from './gender.svg';
import { ReactComponent as GreenIndicator } from './green-indicator.svg';
import { ReactComponent as Grid } from './grid.svg';
import { ReactComponent as GroupedChat } from './grouped-chat.svg';
import { ReactComponent as Height } from './height.svg';
import { ReactComponent as Lock } from './lock.svg';
import { ReactComponent as MiniHamburger } from './mini-hamburger.svg';
import { ReactComponent as OverlappedComment } from './overlapped-comment.svg';
import { ReactComponent as PaperPlane } from './paper-plane.svg';
import { ReactComponent as BirthdayPatientDetails } from './PatientDetail/birthday.svg';
import { ReactComponent as CalculationTab } from './PatientDetail/calculator-tab.svg';
import { ReactComponent as Clock } from './PatientDetail/clock.svg';
import { ReactComponent as CohortsTab } from './PatientDetail/cohorts-tab.svg';
import { ReactComponent as ConditionTab } from './PatientDetail/condition-tab.svg';
import { ReactComponent as GenderPatientDetails } from './PatientDetail/gender.svg';
import { ReactComponent as HeightPatientDetails } from './PatientDetail/height.svg';
import { ReactComponent as MedicationTab } from './PatientDetail/medication-tab.svg';
import { ReactComponent as NoteTab } from './PatientDetail/note-tab.svg';
import { ReactComponent as ProcedureTab } from './PatientDetail/procedure-tab.svg';
import { ReactComponent as VisitTab } from './PatientDetail/visit-tab.svg';
import { ReactComponent as WeightPatientDetails } from './PatientDetail/weight.svg';
import { ReactComponent as RedIndicator } from './red-indicator.svg';
import { ReactComponent as Reload } from './reload.svg';
import { ReactComponent as CalculationIconSidebar } from './Sidebar/calcualtion-icon.svg';
import { ReactComponent as ChatIconSidebar } from './Sidebar/chat-icon.svg';
import { ReactComponent as CheveronIcon } from './Sidebar/cheveron-icon.svg';
import { ReactComponent as CohortsIconSidebar } from './Sidebar/cohorts-icon.svg';
import { ReactComponent as DashboardIconSidebar } from './Sidebar/dashboard-icon.svg';
import { ReactComponent as DataCurationIconSidebar } from './Sidebar/data-curation-icon.svg';
import { ReactComponent as DataIngestionIconSidebar } from './Sidebar/data-ingestion.svg';
import { ReactComponent as DataSourceIconSidebar } from './Sidebar/data-source.svg';
import { ReactComponent as LicenseIconSidebar } from './Sidebar/license-icon.svg';
import { ReactComponent as PatientIconSidebar } from './Sidebar/patient-icon.svg';
import { ReactComponent as SortIcon } from './sort.svg';
import { ReactComponent as Star } from './star.svg';
import { ReactComponent as SuccessLayered } from './success-layered.svg';
import { ReactComponent as Thought } from './thought.svg';
import { ReactComponent as TrendingUp } from './trending-up.svg';
import { ReactComponent as UpperRightArrow } from './upper-right-arrow.svg';
import { ReactComponent as Users } from './users-many.svg';
import { ReactComponent as SingleUser } from './users-single.svg';
import { ReactComponent as Weight } from './weight.svg';

import { icons as CalculationsIcons } from './Calculations';
import { icons as CohortIcons } from './Cohort';
import * as PatientRegistryIcons from './PatientRegistry';
import { icons as SourceRegistryIcons } from './SourceRegistry';

import { ReactComponent as HomeGray } from './home-gray.svg';
import { ReactComponent as HomeBlack } from './home-black.svg';
import { ReactComponent as Audit } from './audit.svg';
export const icons = {
    HomeGray,
    HomeBlack,
    Audit,
    FileDoc,
    FilePdf,
    FileTxt,
    GreenIndicator,
    RedIndicator,
    Download,
    Grid,
    SortIcon,
    CirclePlus,
    Dots,
    Delete,
    CircleDelete,
    Gender,
    Height,
    Weight,
    Age,
    UpperRightArrow,
    OverlappedComment,
    SuccessLayered,
    Star,
    Users,
    SingleUser,
    Reload,
    ArrowUpright,
    PaperPlane,
    DoubleArrowsRight,
    GroupedChat,
    Lock,
    ClockRotateLeft,
    LicenseIconSidebar,
    DashboardIconSidebar,
    CohortsIconSidebar,
    ChatIconSidebar,
    PatientIconSidebar,
    DataCurationIconSidebar,
    DataIngestionIconSidebar,
    DataSourceIconSidebar,
    CalculationIconSidebar,
    CheveronIcon,
    Export,
    CheckIcon,
    Thought,
    Expand,
    MiniHamburger,
    CalculationTab,
    CohortsTab,
    ProcedureTab,
    VisitTab,
    ConditionTab,
    NoteTab,
    ClockRotateRight,
    TrendingUp,
    MedicationTab,
    Clock,
    BirthdayPatientDetails,
    GenderPatientDetails,
    HeightPatientDetails,
    WeightPatientDetails,
    ClinicalTrials,
    ...CalculationsIcons,
    ...SourceRegistryIcons,
    ...CohortIcons,
    ...PatientRegistryIcons,
};

export type IconName = keyof typeof icons;
